import * as React from "react";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TextField from "@mui/material/TextField";
import { useDispatch } from "react-redux";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Hidden from '@mui/material/Hidden';
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

import { setError, setSuccess, setWarning } from "../../reducers/appSlice";
import { useTheme } from "@mui/material/styles";

// Iconos
import IconButton from "@mui/material/IconButton";
import DoneOutlineRounded from "@mui/icons-material/DoneOutlineRounded";
import ClearIcon from "@mui/icons-material/Clear";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import CommentIcon from '@mui/icons-material/Comment';
import PlaylistAddCheckOutlinedIcon from '@mui/icons-material/PlaylistAddCheckOutlined';

// Modal
import Modal from "../../components/Modal";
import VerificarUltimoAdjunto from "../../commons/VerificarUltimoAdjunto";

// Dialogos de botones de acción
import ConfirmDialog from "../../components/ConfirmDialog";

// Buscador de Organismos
import BuscarOrganismo from "../../commons/BuscadorOrganismo";

// rutas de peticiones axios
import api from "../../service/api";
import { DialogActions, Typography } from "@mui/material";

import Accion from "../../components/Accion";

const TablePaginationActions = (props) => {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
            <KeyboardArrowLeft />
          )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
            <KeyboardArrowRight />
          )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
};

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


// arranco el componente //
const Movimientos = (props) => {

  const dispatch = useDispatch();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const verficarElFirmado = () =>{
    formik.setFieldValue("origen", destino);
    setPerfilPermitido(false);
    setOpen(true);
    setVerifica(false);
 };

 const verficarElFirmadoCancelar = () =>{
   setVerifica(false);
};

  const leyendaOrganismo = "Podés buscar directamente por código o acceder al buscador ampliado en la lupa.";

  const date = new Date();

  function formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  const [selected] = useState([]);

  const [page, setPage] = React.useState(0);

  const [rowsPerPage, setRowsPerPage] = React.useState(5);

  var validationSchema = Yup.object().shape({
    fecha: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .min("01/01/1992", "Fecha no válida")
      .max(new Date(), "Fecha no válida"),
    folios: Yup.number().when(props.soporte, {
      is: (props) => soporte === "PAPEL",
      then: Yup.number()
        .positive("Debe ser mayor que cero")
        .required("Requerido")
        .min(props.folios, "Debe ser mayor o igual a " + props.folios)
    }),
    cod_destino: Yup
      .number("Código numérico")
      .required("Requerido")
      .notOneOf([Yup.ref("mi_cod")], "Organismo no permitido"),
    destino: Yup.string()
      .required("Requerido")
      .min(2, "Mínimo 2 caracteres"),
    observaciones: Yup.string()
      .max(150, "Máximo 150 caracteres")
  });

  var validationSchemaRecepcionar = Yup.object().shape({
    fecha_recepcionar: Yup.date()
      .typeError("Formato no válido")
      .required("Requerido")
      .min("01/01/1992", "Fecha no válida")
      .max(new Date(), "Fecha no válida"),
  });

  const formik = useFormik({
    initialValues: {
      tipoInforme: 102,
      visibilidad: 1,
      fecha: formatDate(date),
      folios: props.folios,
      origen: "",
      cod_destino: "",
      destino: "",
      observaciones: "",
      id_tramite: props.id,
      mi_cod: "",
      acciones_guardar: "alta"
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      setSubmitting(true);
      api
        .registrarMovimiento({
          traId: values.id_tramite,
          fecha: values.fecha,
          intId: values.tipoInforme,
          orfidDest: values.cod_destino,
          cantFolios: values.folios,
          observacion: values.observaciones,
          accion: values.acciones_guardar,
        })
        .then((res) => {
          dispatch(setSuccess("Se guardó con éxito"));
          setPerfilPermitido(false);

          setTimeout(() => {
            setOpen(false);
            formik.handleReset();
            props.actualizarDatos();
            buscarMovimientos(filtro);
          }, 1000);
        })
        .catch((e) => {
          setSubmitting(false);
          switch (e.response.data.error) {
            case "Error : Debe ser un expediente para realizar una salida":
              if (perfil === '492') {
                setPerfilPermitido(true);
                formik.setFieldValue("acciones_guardar", "convertir");
                dispatch(setWarning("Debe ser un expediente para realizar una salida"));
              } else {
                setPerfilPermitido(false);
                dispatch(setError(e.response.data.error));
              }
              break;
            case "Error : No es posible registrar el movimiento porque el  expediente está ARCHIVADO":
              setPerfilPermitido(true);
              formik.setFieldValue("acciones_guardar", "recircular");
              dispatch(setWarning("No es posible registrar el movimiento porque el  expediente está ARCHIVADO"));
              break;
            case "Error : No es posible registrar el movimiento porque el  trámite interno está ARCHIVADO":
              setPerfilPermitido(true);
              formik.setFieldValue("acciones_guardar", "recircular");
              dispatch(setWarning("No es posible registrar el movimiento porque el  trámite interno está ARCHIVADO"));
              break;
            default:
              setPerfilPermitido(false);
              formik.setFieldValue("acciones_guardar", "alta");
              dispatch(setError(e.response.data.error));
          }

        })
        .finally(() => setSubmitting(false));
    },
    onReset: () => { },
  });

  const formikRecepcionar = useFormik({
    initialValues: {
      TRA_ID: "",
      fecha_recepcionar: formatDate(date),
    },
    enableReinitialize: true,
    validationSchema: validationSchemaRecepcionar,
    onSubmit: (values) => {
      setSubmittingII(true);
      api
        .recepcionarMovimientoConFecha(values)
        .then((res) => {
          setOpenModalRecepcionar(false);
          dispatch(setSuccess('Se recepcionó con éxito'));
          setSubmittingII(false);
          formikRecepcionar.handleReset();
          setTimeout(() => buscarMovimientos(filtro), 1500);
        })
        .catch((e) => {
          setSubmittingII(false);
          console.log(e.response.data.detalle);
          dispatch(setError(e.response.data.error));
        });

    },
    onReset: () => { },
  });


  const [filtro] = useState({
    id_tramite: props.id,
  });


  const [datos_movimientos, setDatosMovimientos] = useState([]);
  const [soporte] = useState(props.soporte);
  const [destino, setDestino] = useState("");
  const [open, setOpen] = useState(false);
  const [open_modal_xs, setOpenModalXs] = useState(false);
  const [open_modal_recepcion, setOpenModalRecepcionar] = useState(false);
  const [observacion_texto, setObservacion] = useState("dd");
  const [submitting, setSubmitting] = useState(false);
  const [submittingII, setSubmittingII] = useState(false);
  const [buscandoOrganismo, setBuscandoOrganismo] = useState(false);
  const [perfil, setPerfil] = useState(false);
  const [perfil_permitido, setPerfilPermitido] = useState(false);
  const [numero, setNumero] = useState(props.numero);
  const [textoNuevoCodigo, settextoNuevoCodigo] = useState('');

  const [filteredDato, setFilteredDato] = useState([]);

  const [filter, setFilter] = useState("");

  const filterData = (element) => {
    return (element.tipo_movimiento?.toLowerCase().includes(filter.toLowerCase()) || element.origen?.toLowerCase().includes(filter.toLowerCase()) || element.destino?.toLowerCase().includes(filter.toLowerCase()));
  };
  const [verifica, setVerifica] = useState(false);


  const columns = [
    {
      id: "id_movimiento",
      label: "Tipo",
      width: 100,
      align: "left",
    },

    {
      id: "fecha",
      label: "Fecha",
      width: 100,
      align: "center",
    },
    {
      id: "origen",
      label: "Organismo de origen",
      width: 100,
      align: "left",
    },
    {
      id: "destino",
      label: "Organismo de destino",
      width: 100,
      align: "left",
    },
    {
      id: "folios",
      label: "Folios",
      width: 100,
      align: "center",
    },
    {
      id: "fecha_recepcion",
      label: "Recepción",
      width: 100,
      align: "center",
    },
    {
      id: "acciones",
      label: "Acciones",
      width: 100,
      align: "center",
    },
  ]

  const columns_sf = [
    {
      id: "id_movimiento",
      label: "Tipo",
      minWidth: 10,
      width: 10,
      align: "left",
    },

    {
      id: "fecha",
      label: "Fecha",
      minWidth: 200,
      align: "center",
    },
    {
      id: "origen",
      label: "Origen",
      minWidth: 100,
      align: "left",
    },
    {
      id: "destino",
      label: "Destino",
      minWidth: 100,
      align: "left",
    },
    {
      id: "fecha_recepcion",
      label: "Recepción",
      minWidth: 100,
      align: "center",
    },
    {
      id: "acciones",
      label: "Acciones",
      minWidth: 150,
      align: "center",
    },
  ];

  const handleChangeButton = () => {
    if(soporte === 'DIGITAL'){
      setVerifica(true);
    }else{
      formik.setFieldValue("origen", destino);
      setPerfilPermitido(false);
      setOpen(true);
    }
    
  };

  const handleObservaciones = (event, txtobservacion) => {

    setObservacion(txtobservacion);
    setOpenModalXs(true);
  }

  const aceptarModal = () => {
    setOpenModalXs(false);
  }

  const handleRecepcionar = (event, idMov) => {
    formikRecepcionar.setFieldValue("TRA_ID", idMov);
    setOpenModalRecepcionar(true);
  }

  const aceptarModalRecepcionar = (event) => {
    setOpenModalRecepcionar(false);
  }

  const confirmar = () => {
    formik.submitForm();
  }

  const confirm = () => {
    formikRecepcionar.submitForm();
    // props.handleConfirm(props.data);
    // setOpenModalRecepcionar(false);
  };

  const accionConfirmarRecepcion = (datos) => {

    api
      .recepcionarMovimiento({
        TRA_ID: datos,
      })
      .then((res) => {

        var stringRta = res.data;
        var contiene = stringRta.indexOf('Se recepcionó el');

        if (contiene !== -1) {
          dispatch(setSuccess(res.data));
          setTimeout(() => buscarMovimientos(filtro), 1500);
        } else {
          dispatch(setError(res.data));
        }


      })
      .catch((e) => {
        console.log(e.response.data.detalle);
        dispatch(setError(e.response.data.error));
      });

  }

  const accionConfirmarEliminar = (datos) => {

    api
      .eliminarMovimiento({
        movId: datos,
      })
      .then((res) => {

        dispatch(setSuccess("Se eliminó con éxito"));

        setTimeout(() => {
          buscarMovimientos(filtro);
          props.actualizarDatos();
        }, 1500);

      })
      .catch((e) => {
        console.log(e.response.data.detalle);
        dispatch(setError(e.response.data.error));
      });

  }
  const accionConfirmarEliminarRecepcion = (datos) => {

    api
      .eliminarRecepcion({
        movId: datos,
      })
      .then((res) => {

        dispatch(setSuccess("Se eliminó la recepción con éxito"));
        setTimeout(() => buscarMovimientos(filtro), 1500);

      })
      .catch((e) => {
        console.log(e.response.data.detalle);
        dispatch(setError(e.response.data.error));
      });

  }

  const handleOrganismo = (organismo) => {

    if (organismo != null) {
      formik.setFieldValue("cod_destino", organismo.id);
      formik.setFieldValue("destino", organismo.descOrgCompleta);
    } else {
      formik.setFieldValue("destino", '');
    }


  };

  const handleClose = () => {
    setOpen(false);
    formik.handleReset();
    settextoNuevoCodigo('');
  };

  const handleCloseModalXs = () => {
    setOpenModalXs(false);
  };

  const handleCloseModalRecepcionar = () => {
    setOpenModalRecepcionar(false);
    formikRecepcionar.handleReset();
  };

  const handleCloseII = () => {
    setOpenModalRecepcionar(false);
    formikRecepcionar.handleReset();
  }

  const buscarMovimientos = (filtro) => {
    api
      .buscarMovimiento(filtro)
      .then((res) => {

        var codigodestino = res.data.movimientos[0].destino.split(' -');
        var codigo_destino = codigodestino[0];
        formik.setFieldValue("mi_cod", parseInt(codigo_destino));
        formik.setFieldValue("origen", res.data.movimientos[0].destino);
        setDatosMovimientos(res.data.movimientos);
        setFilteredDato(res.data.movimientos);
        setDestino(res.data.movimientos[0].destino);

      })
      .catch((e) => {
        console.log(e);
        dispatch(setError("Error al cargar los datos"));
      });
  };


  const buscarOrganismoPorCodigo = (codigo) => {

    setBuscandoOrganismo(true);
    api
      .buscarOrganismoUltimo({
        id: codigo,
      })
      .then((res) => {
        if (res.data && res.data.length > 0) {
       
          handleOrganismo(res.data[0]);
          if(codigo !== res.data[0].id)
          { 
            settextoNuevoCodigo('Hubo cambios de orgánica y el organismo "'+codigo+'" fue reemplazado por "'+res.data[0].id+'"');
          }else{
            settextoNuevoCodigo('');
          }
          document.getElementById("observaciones").focus();
        } else {
          handleOrganismo();
          dispatch(setError("No se encontró el organismo"));
        }
      })
      .catch((e) => {
        handleOrganismo();
        dispatch(setError("Error al buscar el organismo"));
      })
      .finally(() => {
        setBuscandoOrganismo(false);
      })
  };

  async function verPerfilConectado() {
    try {

      let res = await api.datosUsuario();
      setPerfil(res.data.perfil);

    } catch (e) {
      dispatch(
        setError("Error al consultar mi perfil")
      );
    }
  }

  const handleCodigoOrganismo = (event) => {
    if (event.keyCode === 13 || event.keyCode === 9) {
      if (event.target.value !== "" && event.target.value !== null) {
        setPerfilPermitido(false);
        formik.setFieldValue("acciones_guardar", "alta");
        buscarOrganismoPorCodigo(event.target.value);
      }
    } else if (event.type === "blur" && event.target.value !== "" && event.target.value !== null) {
      setPerfilPermitido(false);
      formik.setFieldValue("acciones_guardar", "alta");
     // buscarOrganismoPorCodigo(event.target.value);
    }
  };

  const handleChangeCodigoDestino = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik.setFieldValue(event.target.id, event.target.value)
    }
    if (formik.values.destino !== "" && formik.values.destino !== null) {
      handleDestino();
      formik.setFieldValue("cod_destino", event.target.value);
    }
  };

  const handleDestino = (destino = null) => {
    if (destino !== null) {
      alert(destino);
    } else {
      formik.setFieldValue("destino", "");
      setPerfilPermitido(false);
    }
  };

  const handleChangeTextField = (event) => {
    if (/^\d*$/.test(event.target.value)) {
      formik.setFieldValue(event.target.id, event.target.value);
    }
  };


  useEffect(() => {
    buscarMovimientos(filtro);
    verPerfilConectado();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (filter) {
      setFilteredDato(datos_movimientos.filter(dato => filterData(dato)));
    } else {
      setFilteredDato(datos_movimientos);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <Grid color="primary">
      <Grid container sx={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", alignItems: "center" }}>
        <Grid item align="right" >
          <TextField
            id="filter"
            name="filter"
            label="BUSCAR"
            variant="outlined"
            size="small"
            margin="dense"
            value={filter}
            onChange={(event) => setFilter(event.target.value)}
          />
        </Grid>
        <Grid item sx={{ display: { xs: "none", sm: "block" }, ml: 2 }} align="right">
          <Accion funcion={props.funcion} accion="alta_movimiento">
            <Button
              variant="verde"
              onClick={handleChangeButton}
              endIcon={<AddIcon />}
              disabled={datos_movimientos.length === 0}
            >
              Nuevo
            </Button>
          </Accion>
        </Grid>
      </Grid>

      <Grid container sx={{ display: { xs: "block", sm: "none" } }} align="right">
        <Accion funcion={props.funcion} accion="alta_movimiento">
          <IconButton
            title="Nuevo"
            size="medium"
            sx={{
              color: "#fff",
              backgroundColor: "#799F4F",
              "&:hover": { color: "#fff", backgroundColor: "#546f37" },
              margin: 1,
            }}
            onClick={handleChangeButton}
            disabled={datos_movimientos.length === 0}
          >
            <AddIcon />
          </IconButton>
        </Accion>
      </Grid>
      <Modal
        open={open}
        handleClose={handleClose}
      >
        <form
          id="formAltaMovimiento"
          name="formAltaMovimiento"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Hidden mdDown>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} sx={{ marginBottom: 2 }}>
                <Typography variant="titulo">NUEVO MOVIMIENTO{numero}</Typography>
              </Grid>
            </Grid>
          </Hidden>
          <Hidden lgUp>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12} sx={{ marginBottom: 2 }}>
                <Typography variant="titulo">NUEVO MOVIMIENTO</Typography>
                <br></br>
                <Typography variant="aclaracion">{numero}</Typography>
              </Grid>
            </Grid>
          </Hidden>
          <Grid container spacing={3}>
            <Grid item lg={12} xs={12} sx={{ marginBottom: 2 }}>
              <TextField
                id="origen"
                name="origen"
                label="Organismo de origen"
                variant="outlined"
                size="small"
                fullWidth
                disabled
                value={formik.values.origen}
                onChange={formik.handleChange}
                error={formik.touched.origen && Boolean(formik.errors.origen)}
                helperText={formik.touched.origen && formik.errors.origen}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item lg={2} xs={12}>
              <TextField
                id="cod_destino"
                name="cod_destino"
                label="Código de organismo"
                variant="outlined"
                size="small"
                inputProps={{ maxLength: 8 }}
                fullWidth
                autoFocus
                value={formik.values.cod_destino}
                onChange={handleChangeCodigoDestino}
                onBlur={handleCodigoOrganismo}
                onKeyDown={handleCodigoOrganismo}
                error={formik.touched.cod_destino && Boolean(formik.errors.cod_destino)}
                helperText={formik.touched.cod_destino && formik.errors.cod_destino}
              />
              <Typography
                variant="aclaracion"
                sx={{
                  display: {
                    xs: "inline",
                    sm: "inline",
                    md: "inline",
                    lg: "none",
                  },
                }}
              >
                {leyendaOrganismo}
              </Typography>
            </Grid>
            <Grid item lg={10} xs={12}>
              <Box display="flex" flexDirection="row">
                <TextField
                  id="destino"
                  name="destino"
                  label="Organismo de destino"
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formik.values.destino}
                  onChange={formik.handleChange}
                  error={
                    formik.touched.destino && Boolean(formik.errors.destino)
                  }
                  helperText={formik.touched.destino && formik.errors.destino}
                  disabled
                />
                {buscandoOrganismo ? (
                  <CircularProgress
                    color="primary"
                    size={20}
                    sx={{ margin: 1 }}
                  />
                ) : (
                    <BuscarOrganismo resultado={handleOrganismo} activo={"T"} alta={"N"} accion="alta"></BuscarOrganismo>
                  )}
              </Box>
            </Grid>
            <Grid container>
              <Typography
                variant="aclaracion"
                sx={{
                  ml: 3,
                  marginTop: 0,
                  display: { xs: "none", sm: "none", md: "none", lg: "inline" },
                }}
              >
                {leyendaOrganismo}
              </Typography>
            </Grid>
          </Grid>
          {soporte === 'PAPEL' ? (
            <Grid container spacing={3} sx={{ marginTop: 0 }}>
              <Grid item lg={8} xs={12}>
                <FormControl
                  variant="outlined"
                  size="small"
                  error={
                    formik.touched.fecha && Boolean(formik.errors.fecha)
                  }
                  fullWidth
                >
                  <TextField
                    id="fecha"
                    name="fecha"
                    type="date"
                    value={formik.values.fecha}
                    label="Fecha del movimiento"
                    variant="outlined"
                    size="small"
                    onChange={formik.handleChange}
                    InputLabelProps={{ shrink: true }} />
                  <FormHelperText>
                    {formik.touched.fecha && formik.errors.fecha}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item lg={4} xs={12} sx={{ marginTop: 0 }}>
                <TextField
                  id="folios"
                  name="folios"
                  label="Folios"
                  variant="outlined"
                  size="small"
                  inputProps={{ maxLength: 5 }}
                  fullWidth
                  value={formik.values.folios}
                  onChange={handleChangeTextField}
                  error={formik.touched.folios && Boolean(formik.errors.folios)}
                  helperText={formik.touched.folios && formik.errors.folios}
                />
              </Grid>
            </Grid>
          ) : (
              <Grid container spacing={3} sx={{ marginTop: 0 }}>
                <Grid item lg={12} xs={12} sx={{ display: "none" }}>
                  <TextField
                    id="folios"
                    name="folios"
                    label="Folios"
                    type="number"
                    variant="outlined"
                    size="small"
                    inputProps={{ maxLength: 5 }}
                    fullWidth
                    value={formik.values.folios}
                    onChange={formik.handleChange}
                    error={formik.touched.folios && Boolean(formik.errors.folios)}
                    helperText={formik.touched.folios && formik.errors.folios}
                  />
                </Grid>
              </Grid>
            )}

          <Grid container spacing={3}>
            <Grid item lg={12} xs={12} sx={{ marginTop: 2 }}>
              <TextField
                id="observaciones"
                name="observaciones"
                label="Observaciones"
                variant="outlined"
                size="small"
                multiline
                inputProps={{ maxLength: 400 }}
                rows={4}
                fullWidth
                value={formik.values.observaciones}
                onChange={formik.handleChange}
                error={formik.touched.observaciones && Boolean(formik.errors.observaciones)}
                helperText={formik.touched.observaciones && formik.errors.observaciones}
              />
            </Grid>
          </Grid>
          <DialogActions sx={{ justifyContent: "flex-start" }}>
            <Typography
              variant="aclaracion"
              sx={{
                display: "inline",
                color: "#D9680B",
              }}
            >
              {textoNuevoCodigo}
            </Typography>
          </DialogActions>
          <Grid container spacing={3}>
            <Grid
              item
              xs={12}
              align="right"
              sx={{ display: { xs: "none", md: "inline" } }}
            >
              <Button
                variant="plata"
                onClick={handleClose}
                endIcon={<ClearIcon />}
                sx={{ m: 1 }}
              >
                {"Cancelar"}
              </Button>{" "}

              {perfil_permitido ? (
                <Button
                  sx={{ m: 1 }}
                  variant="verde"
                  color="primary"
                  type="button"
                  disabled={submitting}
                  endIcon={<DoneOutlineRounded />}
                  onClick={confirmar}
                >
                  {formik.values.acciones_guardar === 'convertir' ?
                    (submitting ? "Confirmando..." : "Convertir en Expediente y Confirmar") : (submitting ? "Confirmando..." : "Recircular y Confirmar")
                  }
                </Button>
              ) : (
                  <Button
                    sx={{ m: 1 }}
                    variant="verde"
                    color="primary"
                    type="button"
                    disabled={submitting}
                    endIcon={<DoneOutlineRounded />}
                    onClick={confirmar}
                  >
                    {submitting ? "Confirmando..." : "Confirmar"}
                  </Button>
                )}

            </Grid>
            <Grid
              item
              xs={12}
              align="right"
              sx={{ display: { xs: "block", md: "none" } }}
            >
              <IconButton color="primary" onClick={handleClose} title="Cancelar">
                <ClearIcon />
              </IconButton>{" "}
              <IconButton
                color="primary"
                type="button"
                disabled={submitting}
                title="Confirmar"
                onClick={confirmar}
              >
                <DoneOutlineRounded />
              </IconButton>
            </Grid>

            <Grid item xs={12} sm={12}>
              {" "}
            </Grid>
          </Grid>
        </form>
      </Modal>

      <Modal open={open_modal_xs} handleClose={handleCloseModalXs} size="sm">
        <Typography variant="titulo" paragraph>
          Observaciones
        </Typography>
        <Typography variant="cuerpo" paragraph>
          {observacion_texto}
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button sx={{ m: 1 }}
            variant="plata"
            onClick={aceptarModal}
          >
            {"Cerrar"}
          </Button>
        </Box>
      </Modal>

      {/* Modal para la nueva recepción */}
      <Modal open={open_modal_recepcion} handleClose={handleCloseModalRecepcionar} size="sm">
        <Typography variant="titulo" paragraph>
          Recepcionar el movimiento
        </Typography>
        <Typography variant="cuerpo" paragraph>
          <form
            id="formRecepcionarMovimiento"
            name="formRecepcionarMovimiento"
            onSubmit={formikRecepcionar.handleSubmit}
            onReset={formikRecepcionar.handleReset}
            noValidate
            autoComplete="off"
          >
            {props.soporte === 'PAPEL' ?
              <Grid container spacing={3} sx={{ marginTop: 0 }}>
                <Grid item lg={8} xs={12}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    error={
                      formikRecepcionar.touched.fecha_recepcionar && Boolean(formikRecepcionar.errors.fecha_recepcionar)
                    }
                    fullWidth
                  >
                    <TextField
                      id="fecha_recepcionar"
                      name="fecha_recepcionar"
                      type="date"
                      value={formikRecepcionar.values.fecha_recepcionar}
                      label="Fecha"
                      variant="outlined"
                      size="small"
                      onChange={formikRecepcionar.handleChange}
                      InputLabelProps={{ shrink: true }} />
                    <FormHelperText>
                      {formikRecepcionar.touched.fecha_recepcionar && formikRecepcionar.errors.fecha_recepcionar}
                    </FormHelperText>
                  </FormControl>
                </Grid>
              </Grid>
              :
              <Typography variant="cuerpo" paragraph>
                ¿Desea recepcionar este movimiento?
                </Typography>
            }
          </form>
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row-reverse",
          }}
        >
          <Button sx={{ m: 1 }} variant="verde" onClick={confirm}>
            {submittingII ? "Confirmando..." : "Confirmar"}
          </Button>
          <Button sx={{ m: 1 }} variant="plata" onClick={handleCloseII}>
            {"Cancelar"}
          </Button>
        </Box>
      </Modal>

      <TableContainer>
        <Table sx={{ border: "1px solid #dee2e6" }}
          aria-label="Table de Movimientos"
          size="small"
        >
          {soporte === "PAPEL" ? (
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "#fff",
                      color: "#3c4b64",
                      minWidth: column.minWidth,
                    }}
                    key={column.id}
                    align={column.align}
                  >
                    <b>{column.label}</b>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
          ) : (
              <TableHead>
                <TableRow>
                  {columns_sf.map((column) => (
                    <TableCell
                      sx={{
                        backgroundColor: "#fff",
                        color: "#3c4b64",
                        minWidth: column.minWidth,
                      }}
                      key={column.id}
                      align={column.align}
                    >
                      <b>{column.label}</b>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
            )}
            {verifica ? (
            <VerificarUltimoAdjunto
              tramiteId = {props.id}
              verficarElFirmado={verficarElFirmado}
              verficarElFirmadoCancelar={verficarElFirmadoCancelar}
            >
            </VerificarUltimoAdjunto>):(null)}
          <TableBody>
            {filteredDato
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((item, index) => (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  sx={
                    index % 2 === 0
                      ? { backgroundColor: "#f2f2f2" }
                      : { backgroundColor: "#fff" }
                  }
                >
                  <TableCell key={item.movimiento_id} align="left" width={100}>{item.tipo_movimiento}</TableCell>
                  <TableCell align="center" width={100}>{item.fecha}</TableCell>
                  <TableCell align="left" width={350}>{item.origen}</TableCell>
                  <TableCell align="left" width={350}>{item.destino}</TableCell>
                  {soporte === 'PAPEL' ? (
                    <TableCell align="center" width={50}>{item.folios}</TableCell>
                  ) : (null)}
                  <TableCell align="center" width={100}>{item.fecha_recepcion}</TableCell>
                  <TableCell align="center" width={200}>
                    {item.observacion ? (
                      <IconButton
                        title="Observaciones"
                        size="small"
                        value={item.observacion}
                        onClick={(event) => {
                          handleObservaciones(event, item.observacion);
                        }}
                      >
                        <CommentIcon fontSize="small" />
                      </IconButton>
                    ) : (
                        <IconButton
                          title="Observaciones"
                          size="small"
                          disabled
                        >
                          <CommentIcon fontSize="small" />
                        </IconButton>
                      )}
                    <Accion funcion={props.funcion} accion="Recepcionar">
                      {item.recepcionar === "S" ?
                        (
                          <IconButton
                            title="Recepcionar el movimiento"
                            size="small"
                            onClick={(event) => {
                              handleRecepcionar(event, props.id);
                            }}
                          >
                            <PlaylistAddCheckOutlinedIcon fontSize="small" />
                          </IconButton>
                        ) : (
                          <IconButton
                            title="Recepcionar el movimiento"
                            size="small"
                            disabled
                          >
                            <PlaylistAddCheckOutlinedIcon fontSize="small" />
                          </IconButton>
                        )
                      }
                    </Accion>
                    <Accion funcion={props.funcion} accion="baja_recepcion">
                      {item.borra_recepcion === "S" ? (
                        <ConfirmDialog
                          text="Eliminar Recepción"
                          subText="¿Desea eliminar esta recepción?"
                          icon={<DeleteSweepIcon fontSize="small" />}
                          iconTitle="Eliminar Recepción"
                          handleConfirm={accionConfirmarEliminarRecepcion}
                          data={item.movimiento_id}
                          mostrar='S'
                        />
                      ) : (
                          <ConfirmDialog
                            text="Eliminar Recepción"
                            subText="¿Desea eliminar esta recepción?"
                            icon={<DeleteSweepIcon fontSize="small" />}
                            iconTitle="Eliminar Recepción"
                            handleConfirm={accionConfirmarEliminarRecepcion}
                            data={item.movimiento_id}
                            mostrar='N'
                          />
                        )
                      }
                    </Accion>
                    <Accion funcion={props.funcion} accion="Baja movimiento">
                      {item.borra_mov === "S" ? (
                        <ConfirmDialog
                          text="Eliminar Movimiento"
                          subText="¿Desea eliminar este movimiento?"
                          icon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                          iconTitle="Eliminar"
                          handleConfirm={accionConfirmarEliminar}
                          data={item.movimiento_id}
                          mostrar='S'
                        />
                      ) : (
                          <ConfirmDialog
                            text="Eliminar Movimiento"
                            subText="¿Desea eliminar este movimiento?"
                            icon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                            iconTitle="Eliminar"
                            handleConfirm={accionConfirmarEliminar}
                            data={item.movimiento_id}
                            mostrar='N'
                          />
                        )}
                    </Accion>
                  </TableCell>
                </TableRow>
              ))
            }
            {filteredDato.length === 0 ? (
              <TableRow>
                <TableCell colSpan="7" align="center">
                  <Typography variant="aclaracion">No hay datos para mostrar</Typography>
                </TableCell>
              </TableRow>
            ) : (
                ""
              )}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[
                  5,
                  10,
                  25,
                  { label: "Todos", value: filteredDato.length },
                ]}
                count={filteredDato.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                selected={selected}
                ActionsComponent={TablePaginationActions}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Grid>
  );
};

export default Movimientos;

